/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState, useCallback, useContext, useMemo } from 'react';
import { Table, FlexboxGrid, Button, SelectPicker, IconButton } from 'rsuite';
import { format, eachDayOfInterval } from 'date-fns';
import { Attachment, Search } from '@rsuite/icons';
import { toast } from 'react-toastify';
import { TableHeaderTooltip, TablePagination } from '~/components/TablePagination1';
import { Container } from '~/styles/tabela';
import api from '~/services/api';
import { GerarCSV as CSV } from '~/utils/gerarCSV';
import { ModalPadrao } from '~/components/Modal';
import formatCurrency from '~/utils/formatCurrency';
import SearchInputTable from '~/components/SearchInputTable';
import { InputDataRange } from '~/components/InputDataRange';
import DetalhesCarteiraDialog from '../CarteiraProfissionais/components/DetalhesCarteiraDialog';
import {
  CelulaRelatorio,
  CelulaRelatorioOpcoes,
} from './components/CelulaRelatorio';
import PagamentoDialog from './components/PagamentoDialog';
import {
  CelulaAcaoRelatorio,
  CelulaAcaoPagamentoRelatorio,
} from './components/CelulaAcaoRelatorio';
import EditarProfissional from '../../Profissionais/EditarProfissional';
import CardTotais from './components/CardTotais';
import { DarkModeContext } from '../../../common/contexts/darkMode';
import ModalEnviarNotificacaoSemConta from './components/ModalEnviarNotificacaoSemConta';
import PageHeader from '../../../components/PageHeader';
import AdvancedFilters from '../../../components/AdvancedFilters';
import { ProfissionalCell } from './components/TablesCells';
import theme from '../../../styles/theme';

const { HeaderCell, Column, Cell } = Table;

function RelatoriosProfissional() {
  const { toggleMode } = useContext(DarkModeContext);
  const [filtroData, setFiltroData] = useState();
  const [datas, setDatas] = useState();
  const [relatorios, setRelatorios] = useState({
    lista: [],
    quantidade: 0,
    valorTotal: 0,
  });
  const modalTitulo = 'Gerar CSV';
  const modalTexto =
    'Tem certeza que deseja gerar este CSV com os filtros atuais?';
  const [atributoSelecionado, setAtributoSelecionado] = useState('nome');
  const [statusFiltro, setStatusFiltro] = useState();
  const [textoDigitado, setTextoDigitado] = useState();
  const [showInfo, setShowInfo] = useState(false);
  const [profInfo, setProfInfo] = useState({ profissional: { id: 0 } });
  const [pagina, setPagina] = useState(1);
  const [modalCSV, setModalCSV] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [carregando2, setCarregando2] = useState(false);
  const [exibirDetalhesDialog, setExibirDetalhesDialog] = useState({
    exibir: false,
  });
  const [pagamentoDialog, setPagamentoDialog] = useState({
    exibir: false,
    relatorio: {},
  });
  const [profissionalEditando, setProfissionalEditando] = useState();
  const [showEditarProfissional, setShowEditarProfissional] = useState(false);
  const [buscarCSV, setBuscarCSV] = useState(false);
  const atributosFiltro = [
    { value: 'nome', label: 'Nome' },
    { value: 'cpf_cnpj', label: 'CPF/CNPJ' },
  ];
  const locale = {
    sunday: 'Dom',
    monday: 'Seg',
    tuesday: 'Ter',
    wednesday: 'Qua',
    thursday: 'Qui',
    friday: 'Sex',
    saturday: 'Sab',
    ok: 'Ok',
    today: 'Hoje',
    yesterday: 'Ontem',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos',
  };
  const [orderBy, setOrderBy] = useState('');

  const buscarRelatorios = useCallback(
    async (csv = false) => {
      setCarregando(true);
      setModalCSV(false);
      try {
        const resposta = await api.get('relatorios/profissional-adm', {
          params: {
            datas: filtroData,
            [atributoSelecionado]: textoDigitado,
            status: statusFiltro,
            pagina,
            orderBy,
            csv: buscarCSV,
          },
        });

        const lista = resposta.data.lista.map((relatorio) => ({
          // ...relatorio,
          ...(buscarCSV === false && relatorio),
          Nome: relatorio.profissional.nome,
          cpf_cnpj: relatorio.profissional.cpf_cnpj,
          estado: relatorio.profissional?.endereco?.bairro?.cidade?.estado?.uf,
          Semana: format(
            new Date(relatorio.semana.replace(/-/g, '/').replace(/T.+/, '')),
            'dd/LL/yyyy'
          ),
          Pagamento: format(new Date(relatorio.pagamento), 'dd/LL/yyyy'),
          Qtd: relatorio.quantidade,
          Valor: relatorio.valor ? formatCurrency(relatorio.valor) : 0,
          Avaliacao:
            relatorio && relatorio.avaliacao && relatorio.avaliacao.toFixed(2),
          Banco:
            relatorio.profissional.conta && relatorio.profissional.conta.banco,
          Agência:
            relatorio.profissional.conta &&
            relatorio.profissional.conta.agencia,
          Conta:
            relatorio.profissional.conta &&
            `${relatorio.profissional.conta.conta} - ${relatorio.profissional.conta.digito}`,
          Pix: relatorio.profissional.pix,
          'Tipo Conta':
            relatorio.profissional.conta &&
            relatorio.profissional.conta.tipo_conta,
          'Cpf Titular':
            relatorio.profissional.conta && relatorio.profissional.conta.cpf,
          Status: relatorio.status,
          Método: relatorio.metodo_pagamento,
        }));
        console.log(lista)
        if (buscarCSV) {
          CSV({
            data: lista,
            download: true,
          });

          setCarregando2(false);
          toast.success(`Foram exportados ${lista.length} registros.`);
          setBuscarCSV(false);
          return;
        }

        setRelatorios({
          lista,
          quantidade: resposta.data.quantidade,
          valorTotal: resposta.data.valorTotal
            ? resposta.data.valorTotal.toFixed(2)
            : 0,
        });
        if (relatorios.quantidade > 0 && relatorios.lista.length === 0)
          setPagina(1);
      } catch (e) {
        if (buscarCSV) {
          setCarregando2(false);
          toast.error('Erro ao Exportar os dados');
          setBuscarCSV(false);
          return;
        }
        toast.error(e.message);
      }

      setCarregando(false);
    },
    [
      pagina,
      filtroData,
      atributoSelecionado,
      textoDigitado,
      statusFiltro,
      orderBy,
      buscarCSV,
      relatorios.quantidade,
      relatorios.lista.length,
      setPagina,
    ]
  );

  useEffect(() => {
    buscarRelatorios();
  }, [buscarRelatorios]);

  function abrirEditarProfissional(profissional) {
    setProfissionalEditando(profissional);
    setShowEditarProfissional(true);
  }

  function fecharEditarProfissional() {
    buscarRelatorios();
    setShowEditarProfissional(false);
  }

  async function atualizarStatus(relatorio) {
    setCarregando(true);
    try {
      if (relatorio.status === 'A Pagar')
        await api.put(
          `/relatorios/profissional/${relatorio.profissional.id}`,
          {},
          {
            params: {
              semana: relatorio.semana,
            },
          }
        );
      else await api.put(`/relatorios/profissional/cancelar/${relatorio.id}`);
      toast.success('Relatório atualizado com sucesso');
      buscarRelatorios();
    } catch (e) {
      toast.error(e.message);
    }
    setCarregando(false);
  }

  function abreServicos(profissional) {
    setProfInfo(profissional);
    setShowInfo(true);
  }
  function fechaServicos() {
    setShowInfo(false);
  }

  const activeFilters = useMemo(() => {
    const filters = [];
    return filters
  }, [])

  const CelulaRelatorioProf = ({ rowData, dataKey, ...props }) => (
    <Cell
      {...props}
      style={{
        background: rowData.status === 'Pago' && `${theme.darkGreen}`,
        color: rowData.status === 'Pago' && `${theme.whiteColor}`,
      }}
    >
      <ProfissionalCell rowData={rowData} />
    </Cell>
  );

  return (
    <Container>
      <PageHeader
        title="Relatórios Profissional"
        subtitle="Aqui você pode visualizar todos os relatórios de profissionais."
        actions={(
          <div
            style={{
              display: 'flex',
              gap: '12px'
            }}>
            <Button
              appearance="ghost"
              startIcon={<Attachment />}
              onClick={() => {
                setModalCSV(true);
              }}
            >
              Exportar CSV
            </Button>
          </div>
        )}
      />
      <AdvancedFilters
        activeFilters={activeFilters}
        header={
          <>
            <SearchInputTable
              estilo={{ width: '300px' }}
              setTextoDigitado={setTextoDigitado}
            />

            <SelectPicker
              appearance="default"
              searchable={false}
              data={atributosFiltro}
              value={atributoSelecionado}
              cleanable={false}
              onChange={(value) => setAtributoSelecionado(value)}
            />
          </>
        }
      >
        <FlexboxGrid justify="start" style={{ gap: '10px' }}>
          <InputDataRange
            ranges={[]}
            isoWeek
            oneTap
            locale={locale}
            onClean={() => {
              setFiltroData(null);
              setDatas([]);
            }}
            onChange={(datasSelecionadas) => {
              setDatas(datasSelecionadas);
              if (datasSelecionadas && datasSelecionadas.length !== 0) {
                const datasIntervalo = eachDayOfInterval({
                  start: datasSelecionadas[0],
                  end: datasSelecionadas[1],
                });
                setFiltroData(datasIntervalo);
              } else {
                setFiltroData(null);
              }
            }}
            value={datas}
            hoverRange="week"
          />

          <SelectPicker
            title={statusFiltro || 'Filtro Status'}
            toggleComponentClass={Button}
            appearance="default"
            searchable={false}
            placeholder="Selecione Status"
            data={[
              { label: 'A Pagar', value: 'A Pagar' },
              { label: 'Pago', value: 'Pago' },
            ]}
            onChange={setStatusFiltro}
          />

          <ModalEnviarNotificacaoSemConta
            filtroData={filtroData}
            textoDigitado={textoDigitado}
            atributoSelecionado={atributoSelecionado}
            statusFiltro={statusFiltro}
          />
        </FlexboxGrid>
      </AdvancedFilters>
      <CardTotais
        numeroProfissionais={relatorios.quantidade}
        totalContratado={relatorios.valorTotal}
      />

      <FlexboxGrid style={{ width: '100%' }}>
        <TablePagination
          carregando={carregando}
          dados={relatorios.lista}
          quantidade={relatorios.quantidade}
          onChangePage={setPagina}
          setOrderBy={setOrderBy}
          wordWrap="break-word"
        >
          <Column resizable width={100}>
            <HeaderCell>
              <TableHeaderTooltip label='Opções' tooltip='Opções' />
            </HeaderCell>
            <CelulaRelatorioOpcoes
              setExibirDetalhesDialog={setExibirDetalhesDialog}
              abrirEditarProfissional={abrirEditarProfissional}
              dataKey="id"
              toggleMode={toggleMode}
            />
          </Column>
          <Column width={320} sortable resizable>
            <HeaderCell>
              <TableHeaderTooltip label='Profissional' tooltip='Profissional' />
            </HeaderCell>

            <CelulaRelatorioProf dataKey="Nome" />
            {/* {(rowData) => (
                <ProfissionalCell rowData={rowData} />
              )} */}
            {/* </CelulaRelatorioProf> */}
          </Column>

          <Column resizable width={120} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Semana' tooltip='Semana' />
            </HeaderCell>
            <CelulaRelatorio dataKey="Semana" />
          </Column>

          <Column resizable width={120} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Pagamento' tooltip='Pagamento' />
            </HeaderCell>
            <CelulaRelatorio dataKey="Pagamento" />
          </Column>

          <Column resizable width={70} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Qtd' tooltip='Qtd' />
            </HeaderCell>
            <CelulaRelatorio dataKey="quantidade" />
          </Column>

          <Column resizable width={120} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Valor' tooltip='Valor' />
            </HeaderCell>
            <CelulaRelatorio dataKey="Valor" />
          </Column>
          <Column resizable width={110} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Avaliação' tooltip='Avaliação' />
            </HeaderCell>
            <CelulaRelatorio dataKey="Avaliacao" />
          </Column>
          <Column resizable width={80}>
            <HeaderCell>
              <TableHeaderTooltip label='Banco' tooltip='Banco' />
            </HeaderCell>
            <CelulaRelatorio dataKey="Banco" />
          </Column>
          <Column resizable width={80}>
            <HeaderCell>
              <TableHeaderTooltip label='Agência' tooltip='Agência' />
            </HeaderCell>
            <CelulaRelatorio dataKey="Agência" />
          </Column>
          <Column resizable width={100}>
            <HeaderCell>
              <TableHeaderTooltip label='Conta' tooltip='Conta' />
            </HeaderCell>
            <CelulaRelatorio dataKey="Conta" />
          </Column>
          <Column resizable width={130}>
            <HeaderCell>
              <TableHeaderTooltip label='Pix' tooltip='Pix' />
            </HeaderCell>
            <CelulaRelatorio dataKey="Pix" />
          </Column>
          <Column resizable width={140}>
            <HeaderCell>Tipo
              <TableHeaderTooltip label='Conta' tooltip='Conta' />
            </HeaderCell>
            <CelulaRelatorio dataKey="Tipo Conta" />
          </Column>
          <Column resizable width={140}>
            <HeaderCell>Cpf
              <TableHeaderTooltip label='Titular' tooltip='Titular' />
            </HeaderCell>
            <CelulaRelatorio dataKey="Cpf Titular" />
          </Column>

          <Column resizable width={100} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Status' tooltip='Status' />
            </HeaderCell>
            <CelulaRelatorio dataKey="Status" />
          </Column>

          <Column resizable width={100}>
            <HeaderCell>
              <TableHeaderTooltip label='Método' tooltip='Método' />
            </HeaderCell>
            <CelulaRelatorio dataKey="Método" />
          </Column>

          <Column resizable width={100}>
            <HeaderCell>
              <TableHeaderTooltip label='Status' tooltip='Status' />
            </HeaderCell>
            <CelulaAcaoRelatorio onClick={atualizarStatus} />
          </Column>
          <Column resizable width={100}>
            <HeaderCell>
              <TableHeaderTooltip label='Pagamento' tooltip='Pagamento' />
            </HeaderCell>
            <CelulaAcaoPagamentoRelatorio
              toggleMode={toggleMode}
              onClick={(relatorio) => {
                setPagamentoDialog({
                  exibir: true,
                  relatorio,
                });
              }}
            />
          </Column>
        </TablePagination>
      </FlexboxGrid>
      <DetalhesCarteiraDialog
        exibir={exibirDetalhesDialog.exibir}
        id_profissional={exibirDetalhesDialog.id_profissional}
        datas={datas}
        onFechar={() => setExibirDetalhesDialog({ exibir: false })}
      />
      <EditarProfissional
        idProfissional={profissionalEditando && profissionalEditando.id}
        showEditarProfissional={showEditarProfissional}
        setShowEditarProfissional={setShowEditarProfissional}
        fecharEditarProfissional={fecharEditarProfissional}
        atualizarLista={buscarRelatorios}
      />

      <ModalPadrao
        openModal={modalCSV}
        carregando={carregando2}
        setOpenModal={setModalCSV}
        title={modalTitulo}
        text={modalTexto}
        funcExec={(csv) => {
          setBuscarCSV(csv); // ← isso controla o CSV dentro do `useCallback`
          buscarRelatorios(csv);
        }}
        csv // ← esta é a correção importante!
      />

      <PagamentoDialog
        relatorio={pagamentoDialog.relatorio}
        exibir={pagamentoDialog.exibir}
        recarregar={buscarRelatorios}
        fechar={() => {
          setPagamentoDialog({
            exibir: false,
            relatorio: {},
          });
        }}
      />
    </Container>
  );
}

export default RelatoriosProfissional;
